import React from "react"
import { Link } from "gatsby"
import Img from 'gatsby-image'
import nextPagesStyles from "../styles/components/next-pages.module.scss"
import usePlaceData from '../static_queries/usePlaceData'
import useRegionData from '../static_queries/useRegionData'
import slugify from 'react-slugify';


export default function NextPages({ currentRegion, currentPlace, isRegion }) {
  const regionSlug = slugify(currentRegion)
  const placeData = usePlaceData()
  const regionData = useRegionData()

    if (isRegion === true) {
      if (currentRegion === 'uruguay') {
        return (
          <div className={nextPagesStyles.wrapper}>
            <h3 className={nextPagesStyles.regions_heading}>Regions</h3>
            <ul className={nextPagesStyles.next_regions}>
              {regionData
                .filter(item => item.node.frontmatter.location.region !== "uruguay")
                .map((item) => (
                  <li key={item.node.id} className={nextPagesStyles.li}>
                    <Link
                      to={item.node.fields.slug}
                    >
                      <div className={nextPagesStyles.next_image}>
                        <Img 
                        fluid={
                          item.node.frontmatter.hero_image.childImageSharp.fluid
                        }
                        alt={item.node.frontmatter.title}
                        />
                      </div>
                    <h4>
                      {item.node.frontmatter.title}
                    </h4>
                    </Link>
                  </li>
                ))}
            </ul> 
          </div>  
        )
      } else {
          return (
            <div className={nextPagesStyles.wrapper}>
              <h3>Places</h3> 
              <ul className={nextPagesStyles.next_places}>
                {placeData
                  .filter(item => item.node.frontmatter.location.region === currentRegion)
                  .map((item) => (
                    <li key={item.node.id}>
                      <Link
                        to={item.node.fields.slug}
                       >
                        <div className={nextPagesStyles.next_image}>
                          <Img
                            fluid={
                            item.node.frontmatter.hero_image.childImageSharp.fluid
                           }
                           alt={item.node.frontmatter.title}
                          />
                        </div>
                        <h4>
                          {item.node.frontmatter.title}
                        </h4>
                      </Link>
                    </li>
                 ))}
              </ul>
              <Link
              to={'/uruguay/guide'}
              >
                <h2>
                  Back to: Uruguay
                </h2>
              </Link>
            </div>
          )
      }
    } else {
        const places = placeData
        .filter(item => item.node.frontmatter.title !== currentPlace)
        .filter(item => item.node.frontmatter.location.region === currentRegion);
        return (
          <div className={nextPagesStyles.wrapper}>
          <h3>More places</h3>
          {places.length ?
            <ul className={nextPagesStyles.next_places}>
              {places.map((item) => (
                <li key={item.node.id}>
                  <Link
                    to={item.node.fields.slug}
                   >
                    <div className={nextPagesStyles.next_image}>
                      <Img
                        fluid={
                        item.node.frontmatter.hero_image.childImageSharp.fluid
                       }
                       alt={item.node.frontmatter.title}
                      />
                    </div>
                    <h4>
                      {item.node.frontmatter.title}
                    </h4>
                  </Link>
                </li>
              ))}
            </ul> 
            : <p className={nextPagesStyles.next_empty}>
                No more places in {currentRegion} to show</p>
          }
          <Link
            to={`/uruguay/regions/${regionSlug}`}
          >
            <h2>
              Back to: {currentRegion}
            </h2>
          </Link>
        </div>
      )
    }
}

/*
              <h3>Regions</h3>
              <ul>
            {regionData
              .filter(item => item.node.frontmatter.location.region !== "uruguay", currentRegion )
              .map((item) => (
                <li key={item.node.id}>
                  <Link
                    to={item.node.fields.slug}
                  >
                  {item.node.frontmatter.title}
                  </Link>
                </li>
              ))}
          </ul>
*/